<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="code" slot-scope="code">
          <div class="text-wrap">
            <div class="font-weight-bold text-wrap">{{code}}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
        <template slot="name" slot-scope="name">
          <div class="text-wrap">
            <div class="font-weight-bold text-wrap">{{name}}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
<!--        <template slot="description" slot-scope="description">
          <div>{{description}}</div>
        </template>-->
        <template slot="category" slot-scope="category">
          <div>{{category.name}}</div>
        </template>
        <template slot="school_class" slot-scope="school_class">
          <div>{{school_class ? school_class.name : null}}</div>
        </template>
        <template slot="action" slot-scope="record">
          <div class="text-nowrap">
            <a-tooltip
              placement="top"
              title="Create inward transaction"
            >
            <a href="javascript:"  class="btn btn-sm btn-success mr-2" @click="showInwardTransactionModal(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fa-lg fe  fe-plus-square" />
              </span>
            </a>
            </a-tooltip>
            <a-tooltip
              placement="top"
              title="Create outward transaction"
            >
            <a href="javascript:" class="btn btn-sm btn-warning mr-2" @click="showOutwardTransactionModal(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fa-lg fe fe-minus-square" />
              </span>
            </a>
            </a-tooltip>
            <a-tooltip
              placement="top"
              title="Edit product"
            >
            <a href="javascript:" class="btn btn-sm btn-light mr-2" @click="showEditModal(record)">
                <i class="btn-addon-icon fe fe-edit" />
            </a>
            </a-tooltip>

            <a-tooltip
              placement="top"
              title="Delete product"
            >
            <a href="javascript:" class="btn btn-sm btn-danger" @click="handleDelete(record)">
                <i class="btn-addon-icon fe fe-trash" />
            </a>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>

    <!-- <edit-school-class ref="editClass" @edited="handleEdited" /> -->
    <edit-product @onEdited="handleAfteredit"></edit-product>
    <inward-transaction @onInwardTransaction="handleAfteredit"></inward-transaction>
    <outward-transaction @onOutwardTransaction="handleAfteredit"></outward-transaction>
  </div>
</template>

<script>
import EditProduct from '@/components/inventory/master/product/edit'
import InwardTransaction from '@/components/inventory/master/product/inwardTransaction'
import OutwardTransaction from '@/components/inventory/master/product/outwardTransaction'

const columns = [
  { title: 'Product Code', width: 100, dataIndex: 'code', scopedSlots: { customRender: 'code' } },
  { title: 'Name', width: 250, dataIndex: 'name', scopedSlots: { customRender: 'name' } },
  // { title: 'Description', dataIndex: 'description', scopedSlots: { customRender: 'description' } },
  { title: 'Category', width: 100, dataIndex: 'category', scopedSlots: { customRender: 'category' } },
  { title: 'Sub Category', width: 100, dataIndex: 'sub_category.name', scopedSlots: { customRender: 'sub_category.name' } },
  { title: 'Class', width: 80, dataIndex: 'school_class', scopedSlots: { customRender: 'school_class' } },
  { title: 'Pur. Amount', width: 90, dataIndex: 'purchase_price', scopedSlots: { customRender: 'purchase_price' } },
  { title: 'Sell Price', width: 80, dataIndex: 'selling_price', scopedSlots: { customRender: 'selling_price' } },
  { title: 'Total Qty.', width: 80, dataIndex: 'product_stock.total_inward_quantity', scopedSlots: { customRender: 'product_stock.total_inward_quantity' } },
  { title: 'Issued Qty.', width: 80, dataIndex: 'product_stock.total_outward_quantity', scopedSlots: { customRender: 'product_stock.total_outward_quantity' } },
  { title: 'Closing Qty.', width: 80, dataIndex: 'product_stock.quantity', scopedSlots: { customRender: 'product_stock.quantity' } },
  // { title: 'Min. Qty.', width: 100, dataIndex: 'product_stock.min_quantity', scopedSlots: { customRender: 'product_stock.min_quantity' } },
  // { title: 'Max. Qty.', width: 100, dataIndex: 'product_stock.max_quantity', scopedSlots: { customRender: 'product_stock.max_quantity' } },
  { title: 'Actions', className: 'text-right', scopedSlots: { customRender: 'action' } },
]
// const fakedata = [
//   { id: 1, name: 'Eletronics', description: 'Category for electronics items' },
//   { id: 2, name: 'Fashion', description: 'Category for Fashion items' },
//   { id: 3, name: 'Furniture', description: 'Category for Furniture items' }
// ]
// const exposedEvents = { OnSubmit: 'onsubmit', OnEdit: 'onedit', OnDelete: 'ondelete' }

export default {
  name: 'ProductsTable',
  components: {
    EditProduct,
    InwardTransaction,
    OutwardTransaction,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    rolesetting: { type: Object },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
      showeditform: false,
      datatoedit: {},
      // data: [],
    }
  },
  /* mounted: function () {
    this.fetchdata()
  }, */
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    /* fetchdata() {
      let api = '/api/inventory/product/stock/all'
      this.data.length = 0
      this.$http.get(api)
        .then((resp) => {
          this.data = resp.data.data
        })
        .catch(err => {
          console.error(err)
        })
    }, */
    handleAfteredit() {
      this.$emit('updateTable')
    },
    showInwardTransactionModal(record) {
      this.$eventBus.$emit('showInwardTransactionForm', record)
    },
    showOutwardTransactionModal(record) {
      this.$eventBus.$emit('showOutwardTransactionForm', record)
    },
    showEditModal(record) {
      this.$eventBus.$emit('openEditForm', record)
    },
    closeEditform() {
      this.showeditform = false
    },
    handleDelete(record) {
      this.$confirm({
        title: 'Are you sure to delete this record?',
        content: 'Clicking yes will delete this product.',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/inventory/product/' + record.id)
            .then((resp) => {
              // this.$emit('updateTable')
              if (resp.status === 200) {
                this.$emit('updateTable') // Reload the table
                this.$nprogress.done()

                this.$notification['success']({
                  message: 'Deleted Successfully!',
                  description: 'The product has been deleted.',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data. Please try again later.',
                })
              }
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>

<style>

</style>
